import Vue from 'vue'

Vue.filter('fixedName', (name) => {
  if (name === 'Latin America/Caribbean') { name = 'Latin America and the Caribbean' }
  if (name === 'Asia/Pacific') { name = 'Asia and the Pacific' }
  if (name === 'Viet Nam') { name = 'Vietnam' }
  if (name === 'Cape Verde') { name = 'Cabo Verde' }
  return name
})

// returns a color name based on a 0-1 value
Vue.filter('valueColor', (value) => {
  let result = 'gray-lighter'

  if (parseFloat(value) > 0.7) { result = 'valuegreen' }
  if (parseFloat(value) <= 0.7 && parseFloat(value) >= 0.4) { result = 'valueyellow' }
  if (parseFloat(value) < 0.4) { result = 'valuered' }

  return result
})

// Returns a regime color name based on country data
Vue.filter('regimeColor', (countryData) => {
  if (parseInt(countryData.dem) === 1) {
    return 'regime-orange'
  } else if (parseInt(countryData.dem) === 2) {
    return 'regime-purple'
  } else if (parseInt(countryData.dem) === 3) {
    if (parseInt(countryData.demperf) === 1) {
      return 'regime-dem-low'
    } else if (parseInt(countryData.demperf) === 2) {
      return 'regime-dem-mid'
    } else if (parseInt(countryData.demperf) === 3) {
      return 'regime-dem-high'
    }
  }

  return 'gray-light'
})



// WEBPACK FOOTER //
// ./src/filters.js